import { takeEvery, put } from 'redux-saga/effects';
import { request } from '../../../api/Service';
import { getErrorMessage } from '../../../components/utils/errorHandler';
import { toast } from 'react-toastify';
import {store} from "../../store";
export default function* watcherGetProfitabilityReportSaga() {
  yield takeEvery('LOAD_PROFITABILITY_REPORT', workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: 'DISPLAY_LOADER', payload: payload });
    var payload = {};
    var formatUrl = `profitability-report?startDate=${action.payload.startDate}&endDate=${action.payload.endDate}&locationId=${action.payload.locationId}`;
    yield request('get', {}, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: 'PROFITABILITY_REPORT', payload: payload });
    var formatUrl =
      'api/Admin/get-user-location-dropdown?userId=' +
      store.getState().persistReducer.userId;
    yield request('get', {}, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: 'LOCATIONS_LIST_DROPDOWN', payload: payload });
    yield put({ type: 'DISPLAY_LOADER' });
  } catch (e) {
    yield put({ type: 'DISPLAY_LOADER', payload: payload });
    yield put({ type: 'LOADING_BUTTON_SPINNER' });
    console.log('profitabilityReport', e);
    console.log('profitabilityReport', e.response);
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: 'API_ERRORED', payload: e });
  }
}
